import clsx from 'clsx';
import { useNamespace } from 'components/templates/Translation/TranslationWrapper';
import { useTranslation } from 'next-i18next';
import React from 'react';
import classes from './Input.module.scss';

interface Props {
  className?: string;
  placeholder?: string;
}

const Input = React.forwardRef<HTMLInputElement, Props & React.HTMLProps<HTMLInputElement>>(
  function Input({ className, placeholder, ...rest }, ref) {
    const namespace = useNamespace();
    const { t } = useTranslation(namespace);
    return (
      <input
        ref={ref}
        placeholder={placeholder && t(placeholder)}
        className={clsx(classes.input, className)}
        {...rest}
      />
    );
  },
);
export default Input;
